<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_badge") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #7514b7">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Badge Name (Arabic) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.badge_name') + ' (' + $t('PLACEHOLDERS.ar') + ')'
            "
            v-model.trim="data.nameAr"
            disabled
          />
          <!-- End:: Badge Name (Arabic) -->

          <!-- Start:: Badge Name (English) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.badge_name') + ' (' + $t('PLACEHOLDERS.en') + ')'
            "
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Badge Name (English) -->

          <!-- Start:: Badge Image Display -->
          <div class="col-12 mb-4 d-flex flex-column gap-2">
            <div
              class="input_wrapper d-flex flex-column gap-2 justify-content-center py-2"
            >
              <label>{{ $t("PLACEHOLDERS.badge_image") }}</label>
              <div class="image_preview_wrapper mt-2" v-if="data.image">
                <img
                  :src="data.image"
                  :alt="data.nameAr"
                  class="rounded"
                  style="
                    max-width: 200px;
                    max-height: 200px;
                    object-fit: contain;
                  "
                />
              </div>
            </div>
          </div>
          <!-- End:: Badge Image Display -->

          <!-- Start:: Points Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.points')"
            v-model.number="data.points"
            disabled
          />
          <!-- End:: Points Input -->

          <!-- Start:: Activity Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.activity')"
            v-model="data.activityName"
            disabled
          />
          <!-- End:: Activity Input -->

          <!-- Start:: Earn Condition Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.earn_condition')"
            v-model="data.earnConditionLabel"
            disabled
          />
          <!-- End:: Earn Condition Type -->

          <!-- Start:: Earn Condition Value Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.earn_condition_value')"
            v-model.number="data.earnConditionValue"
            disabled
          />
          <!-- End:: Earn Condition Value Input -->

          <!-- Start:: Period Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.period_days')"
            v-model.number="data.period"
            disabled
          />
          <!-- End:: Period Input -->

          <!-- Start:: Created Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model="data.createdAt"
            disabled
          />
          <!-- End:: Created Date -->
          <!-- Start:: gender  -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.gender')"
            v-model="data.gender"
            disabled
          />
          <!-- End:: gender  -->
          <!-- Start:: Status Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.isActive
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.isActive"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Status Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowBadge",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Display
      data: {
        nameAr: null,
        nameEn: null,
        image: null,
        points: null,
        activityName: null,
        earnConditionLabel: null,
        earnConditionValue: null,
        period: null,
        isActive: false,
        createdAt: null,
      },
      // End:: Data Collection To Display
    };
  },

  computed: {
    // Activities List
    activities() {
      return [
        { id: 1, name: this.$t("ACTIVITIES.walking_running") },
        { id: 2, name: this.$t("ACTIVITIES.cycling") },
        { id: 3, name: this.$t("ACTIVITIES.horse_riding") },
      ];
    },
  },

  methods: {
    // Start:: Show Badge Data
    async showBadge() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `badges/${this.$route.params.id}`,
        });

        const badge = res.data.data.Badge;

        // Set badge data
        this.data.nameAr = badge.trans?.name?.ar || badge.name;
        this.data.nameEn = badge.trans?.name?.en || badge.name;
        this.data.image = badge.image;
        this.data.points = badge.points;
        this.data.gender = badge.gender_label;

        this.data.earnConditionLabel = badge.earn_condition_label;
        this.data.earnConditionValue = badge.earn_condition_value;
        this.data.period = badge.period;
        this.data.isActive = badge.is_active;
        this.data.createdAt = badge.created_at;

        // Get activity name by ID
        const activity = this.activities.find(
          (a) => a.id === badge.activity_id
        );
        this.data.activityName = activity ? activity.name : badge.activity_id;
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.somethingWrong")
        );
      }
    },
    // End:: Show Badge Data
  },

  created() {
    // Start:: Fire Methods
    this.showBadge();
    // End:: Fire Methods
  },
};
</script>
